import { useCallback } from "react";
import { cloneDeep } from "lodash";
import { useFormAPI } from "@/widgets/classic-form/form";
import { LOCATION_EXACTNESS_SCOPE } from "@/entities/place";
import { useEventFieldsWithExactnessDisabled } from "../shared/useEventFieldsWithExactnessDisabled";

export const useToggleEventExactness = () => {
    const { setFieldValue, getFieldValue } = useFormAPI();
    const config = useEventFieldsWithExactnessDisabled();

    return useCallback(
        (newValue: boolean) => {
            const eventValues = getFieldValue("events");
            const valuesCopy = cloneDeep(eventValues);
            Object.entries(valuesCopy).forEach(([eventKey, event]) => {
                const yearDisabled = config.yearDisabled.has(eventKey);
                const placeDisabled = config.placeDisabled.has(eventKey);

                event.instances.forEach((instance) => {
                    if (!newValue) {
                        if (!instance.isRangeMode && !yearDisabled) {
                            instance.dateProximity.year = null;
                            instance.dateProximity.month = null;
                            instance.dateProximity.day = null;
                        }
                        if (!placeDisabled) {
                            instance.locationExactness = null;
                        }
                        return;
                    }

                    if (!instance.isRangeMode && !yearDisabled) {
                        // Should override only nullable values, preserving user-selected proximity
                        if (instance.dateProximity.year === null) {
                            instance.dateProximity.year = 0;
                            instance.dateProximity.month = 0;
                            instance.dateProximity.day = 0;
                        }
                    }
                    if (!placeDisabled && !instance.locationExactness) {
                        instance.locationExactness = LOCATION_EXACTNESS_SCOPE.ThisPlace;
                    }
                });
            });
            setFieldValue("events", valuesCopy);
        },
        [getFieldValue, setFieldValue, config],
    );
};
